module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-info"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '40vw'
    }),
    attrs: {
      "header": "Leave Type",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "p-fluid p-formgrid p-grid"
        }, [_c('div', {
          staticClass: "p-field p-col-12 p-md-6"
        }, [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": !_vm.editing ? 'Add' : 'Update'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addLeaveType.apply(null, arguments)
            }
          }
        }), _vm._v(" "), (!_vm.editing) ? _c('Button', {
          staticClass: "p-button-raised p-button-info",
          attrs: {
            "label": "Add & New"
          }
        }) : _vm._e(), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancel.apply(null, arguments)
            }
          }
        })], 1)])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "name"
    }
  })], 1)])])], 1), _vm._v(" "), _c('DataTable', {
    staticClass: "p-datatable-responsive-demo p-datatable-gridlines",
    attrs: {
      "value": _vm.leaveTypeList,
      "paginator": true,
      "rows": 8,
      "filters": _vm.filters
    },
    scopedSlots: _vm._u([{
      key: "empty",
      fn: function() {
        return [_vm._v("No record found")]
      },
      proxy: true
    }])
  }, [_c('Column', {
    attrs: {
      "header": "S.N"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(sl) {
        return [_vm._v("\n        " + _vm._s(sl.index + 1) + "\n      ")]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Name",
      "sortable": true,
      "field": "value",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['value']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'value', $$v)
            },
            expression: "filters['value']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-pencil"
          },
          on: {
            "click": function($event) {
              return _vm.editLeaveType(slotProps.data)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.openDeleteDialog(slotProps.data.id)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('DeleteDialog', {
    on: {
      "cancel": _vm.cancelDelete,
      "deleted": _vm.deleteLeaveType
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb63e9f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Leave/leaveType.vue
// module id = 2447
// module chunks = 0